<template>
  <page-layout class="ranking">
    
    <display-container :section="611" :no-auto-link="true" class="title">
      <template v-slot="{ component, row }">
        <div class="title_top">
          <p>{{component.getTitle(row)}}</p>
        </div>
      </template>
    </display-container>

    <article class="inner">


      <div class="contents_wrap">
        <div v-for="(group, index) in rankings">

          <div class="container" v-for="ranking in group" :key="ranking.idx">
            <h3>{{ ranking.title }}<i>- {{ ranking.subject }}</i></h3>
            <table class="ranktable">
              <tbody>
                <tr>
                  <th v-for="(row, cindex) in ranking.data.header" :key="`${ranking.idx}_header_${cindex}`">{{row.value}}</th>
                </tr>
                <tr v-for="(row, rindex) in ranking.data.body" :key="`${ranking.idx}_body_${rindex}`">
                  <td v-for="(col, cindex) in row">
                    <div v-if="cindex === 0">
                      <span v-if="col.value">{{ col.value | comma }}</span>
                      <span v-else>{{ rindex + 1 }}<sup>{{convertOrdinalNumber(rindex + 1)}}</sup></span>
                    </div>
                    <div v-else>
                      <a v-if="col.link" :href="col.link" target="_blank">{{ col.value | comma }}</a>
                      <span v-else>
                        <span v-if="ranking.data.header[cindex].value.toLowerCase() === 'country' && col.value === ''" class="tbd">TBD</span>
                        <img v-else-if="ranking.data.header[cindex].value.toLowerCase() === 'country'" class="flag" :src="`/statics/img/flags/${col.value}.svg`">
                        <span v-else>{{ col.value | comma }}</span>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- middle AD 반복 -->
          <!--<div class="ad_wrap mid" v-show="index < group.length">-->
          <div class="ad_wrap mid">
            <div class="inner">

              <display-container :section="311" empty-bg-color="transparent">
                <template v-slot="{ component, row }">
                  <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
                </template>
              </display-container>

              <!-- PC -->
              <!--<ins class="adsbygoogle"
               style="display:block"
               data-ad-client="ca-pub-5310971739125617"
               data-ad-slot="2528443840"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>-->

              <!-- M -->
              <!--<ins class="adsbygoogle"
               style="display:block"
               data-ad-client="ca-pub-5310971739125617"
               data-ad-slot="1019921057"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>-->

            </div>
          </div>

        </div>
      </div>

      <!-- 하단 문구 -->
      <div class="btm_txt">
        <ul>
          <li>※ 최신 업데이트 : {{ lastUpdated }}</li>
          <li>※ 데이터출처 : Global Poker Index(GPI), The Hendon Mob(THM)</li>
          <!--<li>※ 유튜브채널 : 포커 관련 정기적 콘텐츠 제작 및 기준(개인/회사 포함)</li>-->
        </ul>
      </div>

    </article>

    <sub-page-layout></sub-page-layout>

  </page-layout>
</template>

<script>
	import Vue from 'vue'
  import {Dialog, Popover} from 'element-ui'
  import {QDialog, QBtn, QBtnGroup, Loading, QSlideTransition, QDate, QCard, QSeparator} from 'quasar'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import PageLayout from '../layouts/PageLayout'
  export default {
    name: "Ranking",
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      QDialog, QBtn, QBtnGroup, QCard, QDate, QSeparator,
      [Dialog.name]: Dialog,
      [Popover.name]: Popover,
      Loading,
      QSlideTransition,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | Ranking`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `Poker ranking information`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `Ranking | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `Poker ranking information`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        rankings: [],
        lastUpdated: ''
      }
    },
    mounted() {
      this.getRankings()
    },
    computed: {
      ...CommonComputed,
      getAccess () {
        return 'pc'
      },
    },
		methods: {
      ...CommonMethods,
      getRankings () {
        this.axios.get('/rankings/last_updated').then(rs => {
          this.lastUpdated = rs.data
        })
        this.axios.get('/rankings').then(rs => {
          this.rankings = this.division(rs.data, 2)
        })
      },
      division (arr, n) {
        const length = arr.length
        const divide = Math.floor(length / n) + (Math.floor(length%n) > 0 ? 1 : 0)
        const newArr = []
        for (let i = 0; i <= divide; i++) {
          newArr.push(arr.splice(0, n))
        }
        return newArr.filter(x => x.length > 0)
      }
    }
  }
</script>

<style scoped>
  .ranking .sub-page-layout {
    display: none;
  }
  .ranking {
    position: relative;
    top: -40px;
  }
  .ranking .title {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
    margin-bottom: 40px;
  }
  .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
  .container {
    display: inline-block;
    width: 580px;
  }
  /*.container:nth-child(odd) {*/
  /*  margin-right: 60px;*/
  /*}*/
  /deep/ .container:nth-child(1) {
    margin-right: 60px;
  }
  .container h3 {
    font-family: 'Roboto Slab';
    font-size: 24px;
    font-weight: 900;
    letter-spacing: -0.01em;
    margin-bottom: 10px;
  }
  .container h3 i {
    font-size: 20px;
    font-weight: 500;
    margin-left: 8px;
  }
  .ranktable {
    width: 100%;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.03em;
    background: #fff;
  }
  .ranktable tr {
    height: 60px;
  }
  .ranktable tr:nth-child(odd) {
    background: #f8f8f8;
  }
  .ranktable th {
    font-weight: 700;
    color: rgba(0,255,100,1.0);
    background: #000;
    vertical-align: middle;
    line-height: 1.0em;
  }
  .ranktable td {
    vertical-align: middle;
    text-align: center;
    line-height: 1.0em;
    position: relative;
  }
  .ranktable th:first-child,
  .ranktable td:first-child {
    /*padding-left: 10px;*/
  }
  .ranktable th:last-child,
  .ranktable td:last-child {
    /*text-align: right;
    padding-right: 20px;*/
  }
  .ranktable td sup {
    font-size: 0.8em;
  }
  .ranktable td .flag {
    position: relative;
    width: 24px;
    border: 1px solid rgba(0,0,0,0.75);
  }
  .ranktable td a {
    color: #379339;
    text-decoration: underline;
  }
  .ranktable td a:hover {
    color: #000;
  }
  .ranktable td .tbd {
    font-size: 0.9em;
    color: rgba(0,0,0,0.55);
  }
  .btm_txt {
    margin-top: 60px;
  }
  .btm_txt li {
    font-weight: 500;
    line-height: 1.8em;
  }
  .contents_wrap > div:last-child .ad_wrap {
    display: none;
  }
</style>
